import type { OptionsMap } from '@openx/types/options';
import type { RetargetingFormState } from '@openx/types/targeting/retargeting';
import { noop } from '@openx/utils/noop';
import type { TargetingItemsProps } from '../types';
import { SegmentListDisplay } from './components/SegmentListDisplay';

type RetargetingItemsProps = TargetingItemsProps<RetargetingFormState> & {
  onClear: () => void;
  isLoading?: boolean;
  options?: OptionsMap;
};

export const Items = ({
  targetingParams,
  readonly = true,
  onClear = noop,
  isLoading = false,
  options,
}: RetargetingItemsProps) => {
  return (
    <SegmentListDisplay
      segment={targetingParams}
      readonly={readonly}
      onClear={onClear}
      isLoading={isLoading}
      options={options}
    />
  );
};
